import React, { useState } from "react";
import { Clock, MapPin, Star } from "lucide-react";
import { CATEGORY_STYLES } from "../data/events";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export default function EventCard({ event, cityImage }) {
  const src = event.image || cityImage || "";
  const [imgOk, setImgOk] = useState(!!src);
  const catClass = CATEGORY_STYLES[event.category] || CATEGORY_STYLES.Meetup;
  const d = new Date(event.date + "T00:00:00");
  const day = d.getDate();
  const mon = MONTHS[d.getMonth()];

  return (
    <a
      href={event.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex gap-4 rounded-lg border border-border/60 bg-secondary/20 p-3 transition-colors hover:border-ring hover:bg-secondary/40"
    >
      {/* Thumbnail */}
      <div className="relative h-[64px] w-[88px] shrink-0 overflow-hidden rounded-md bg-secondary sm:h-[74px] sm:w-[104px]">
        {imgOk ? (
          <img
            src={src}
            alt={event.title}
            onError={() => setImgOk(false)}
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-secondary to-muted text-[11px] font-medium text-muted-foreground">
            {event.category}
          </div>
        )}
        <div className="absolute left-1 top-1 flex flex-col items-center rounded bg-background/85 px-1.5 py-0.5 leading-none backdrop-blur">
          <span className="text-[13px] font-bold text-foreground">{day}</span>
          <span className="text-[9px] uppercase text-muted-foreground">{mon}</span>
        </div>
      </div>

      {/* Content */}
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <span className={`rounded border px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${catClass}`}>
            {event.category}
          </span>
          {event.major && (
            <span className="inline-flex items-center gap-1 rounded border border-brand/30 bg-brand/10 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-brand">
              <Star className="h-2.5 w-2.5" /> Major
            </span>
          )}
          {event.free && (
            <span className="rounded border border-emerald-500/30 bg-emerald-500/10 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-emerald-400">
              Free
            </span>
          )}
        </div>

        <h3 className="mt-1.5 line-clamp-2 text-[15px] font-semibold leading-snug text-foreground group-hover:underline">
          {event.title}
        </h3>

        <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-[12.5px] text-muted-foreground">
          <span className="inline-flex items-center gap-1">
            <Clock className="h-3.5 w-3.5" /> {event.time}
          </span>
          {event.organizer && <span className="truncate">{event.organizer}</span>}
          {event.venue && (
            <span className="inline-flex items-center gap-1 truncate">
              <MapPin className="h-3.5 w-3.5" /> {event.venue}
            </span>
          )}
        </div>
      </div>
    </a>
  );
}
